export const VARIABLES_LIST_HEIGHT = 2000
